import { usePaymentCardManager } from '../utils/manager/payment-card-manager';
import { usePaymentPixManager } from '../utils/manager/payment-pix-manager';
import { useInterval } from './use-interval';
import { useStorage } from './use-storage';

function usePaymentInterval(
  { payment, orders, onPaymentPaid, onPaymentCancelled } = {},
  enabled = true
) {
  const { refreshPaymentPix } = usePaymentPixManager();
  const { refreshPaymentCard } = usePaymentCardManager();
  const { paymentRef } = useStorage();

  useInterval(
    async () => {
      if (payment == null || orders == null) return;

      // let status = parsePaymentStatus(payment?.status);
      let status = payment?.status;

      if (payment.card != null) {
        await refreshPaymentCard({ payment, orders });
      } else if (payment.pix != null) {
        await refreshPaymentPix({ payment, orders });
      }

      // const newStatus = parsePaymentStatus(paymentRef.current?.status);
      const newStatus = paymentRef.current?.status;
      if (status !== newStatus) {
        status = newStatus;

        if (paymentRef.current?.cancelled_at != null) {
          await onPaymentCancelled?.call(this);
        }

        if (status === 'paid') {
          await onPaymentPaid?.call(this);
        }
      }
    },
    5000,
    payment?.status === 'paying' && enabled,
    [enabled, payment?.status]
  );
}

export { usePaymentInterval };
